export default "__VITE_ASSET__CUuu$UOu__"